import styled from "styled-components";
import { StyledCtaButton } from "../../ctaButton/ctaButton.style";

export const StyledButton = styled(StyledCtaButton)`
  padding: 8px 16px;
  border-radius: 20px !important;

  color: ${({ theme }) => theme.colors.neutralsWhite};
  ${({ theme }) => theme.fontStyles.DesktopCopyLargeBodyCopyBold}
  background-color: ${({ theme }) => theme.colors.primaryBackground};
  border-radius: 20px !important;

  &:active,
  &:focus {
    background-color: ${({ theme }) => theme.colors.primaryBackgroundSelected};
    box-shadow: none;
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.primaryBackgroundHover};
    box-shadow: none;
  }

  &.disabled,
  &:disabled {
    background-color: ${({ theme }) => theme.colors.primaryBackgroundDisabled};
    cursor: not-allowed;
  }
`;

export const StyledForm = styled.form`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .form-title {
    color: ${({ theme }) => theme.colors.neutralsText};
    ${({ theme }) => theme.fontStyles.DesktopHeadlinesH5}
    font-weight: 500;
  }

  .form-description {
    margin-top: 12px;
    color: ${({ theme }) => theme.colors.neutralsTextLight};
    ${({ theme }) => theme.fontStyles.CommentsBody}
  }

  .form-input {
    height: 60px;

    input {
      &:focus,
      &:focus-visible {
        box-shadow: none;
        -webkit-box-shadow: none;
        outline: none;
      }
    }
  }
`;

export const StyledWrapper = styled.div`
  padding: 50px 40px;
  width: 308px;
  background-color: ${({ theme }) => theme.colors.primaryLightFill};
  border-radius: 4px;
  flex: 0 0 auto;
`;
